import ActivityIcon from 'components/atoms/icons/activityIcon';
import { useTranslation } from 'react-i18next';
import ActivityTable from 'components/molecules/activity-table';
import { memo, type FC } from 'react';
import useUser from 'utils/useUser';
import { ModuleType } from 'infrastructure/enums';
import ActivityStatusSelectBox from 'components/molecules/activity-status-select-box';
import { usePatientActivity } from 'infrastructure/hooks/rpm/activity/use-patient-activity';

import s from './styles.module.scss';

interface PatientActivityProps {
  patientGuid: string;
}
const PatientActivity: FC<PatientActivityProps> = ({ patientGuid }) => {
  const { t } = useTranslation();
  const {
    activity,
    queryKey,
    Alert,
    isLoading,
    isFetching,
    status,
    page,
    setPage,
    handleChangeType,
    onSort,
  } = usePatientActivity({ patientGuid });
  const { isMobileDevice, isPatient } = useUser();

  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <h4 className={s.title}>
          <ActivityIcon />
          {t('labels.activity')}
        </h4>
        {!isPatient && (
          <div className={s['header-select']}>
            {isMobileDevice ? (
              <p>{t('labels.type')}:</p>
            ) : (
              <p>{t('labels.activitiesType')}:</p>
            )}
            <ActivityStatusSelectBox
              value={status}
              style={{ width: isMobileDevice ? 120 : 160 }}
              onChange={handleChangeType}
            />
          </div>
        )}
      </div>
      {!isMobileDevice && <div className={s.divider} />}
      <div className={s.body}>
        <ActivityTable
          activity={activity}
          loading={isLoading || isFetching}
          page={page}
          setPage={setPage}
          itemsQueryKey={queryKey}
          view="patient"
          onSort={onSort}
          module={ModuleType.RPM}
          status={status}
        />
      </div>
      {Alert}
    </div>
  );
};
export default memo(
  PatientActivity,
  (prev, next) => prev.patientGuid === next.patientGuid,
);
